import { format } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Chip, Stack, Tooltip } from '@mui/material';
import { compact, isEmpty, values } from 'lodash';

import { SortKey } from 'enums/common.enum';
import { casingFormat, formatStateFilterLabel } from 'common/utils';
import { ExternalOrdersFieldKeys } from 'enums/order.enum';
import { updateProcessedExternalOrdersFilter } from 'store/thunks/workQueueThunks';

const ProcessedExternalOrdersFilterStatusBar = () => {
  const dispatch = useDispatch();
  const filter = useSelector(({ workQueue }) => workQueue.processedExternalOrders.filter);
  const partners = useSelector(({ auth, partner }) => partner[auth.currentTenantId]);

  const removeFilter = (filterName) => () => {
    dispatch(
      updateProcessedExternalOrdersFilter({
        filter: {
          ...filter,
          [filterName]: undefined,
        },
      })
    );
  };

  const removeAllFilter = () => dispatch(updateProcessedExternalOrdersFilter({ filter: {} }));
  return (
    <Stack
      spacing={1}
      direction='row'
      flexWrap='wrap'
      rowGap={1}
      alignItems='center'
      sx={{ maxWidth: '80rem' }}
    >
      {filter?.orderId && (
        <Chip
          label={`Order Id = ${filter.orderId}`}
          variant='contained'
          onDelete={removeFilter(ExternalOrdersFieldKeys.ORDER_ID)}
        />
      )}

      {filter?.patientName && (
        <Chip
          label={`Patient Name = ${filter.patientName}`}
          variant='contained'
          onDelete={removeFilter(ExternalOrdersFieldKeys.PATIENT_NAME)}
        />
      )}

      {filter?.partnerName && (
        <Chip
          label={`Partner Name = ${filter.partnerName}`}
          variant='contained'
          onDelete={removeFilter(ExternalOrdersFieldKeys.PARTNER_NAME)}
        />
      )}

      {filter.partnerIds && (
        <Chip
          label={
            <Tooltip
              title={`Partner = ${filter?.partnerIds
                .map((partnerId) => {
                  const partner = partners?.find((p) => p?.partnerUuid === partnerId);
                  return casingFormat(partner?.partnerName || '');
                })
                .join(', ')}`}
            >
              <Box
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {formatStateFilterLabel(
                  filter?.partnerIds?.map((partnerId) => {
                    const partner = partners?.find((p) => p?.partnerUuid === partnerId);
                    return casingFormat(partner?.partnerName || '');
                  }),
                  'Partner'
                )}
              </Box>
            </Tooltip>
          }
          key='partners'
          variant='contained'
          onDelete={removeFilter('partnerIds')}
        />
      )}

      {filter?.status && (
        <Chip
          label={`Order Status = ${filter.status}`}
          variant='contained'
          onDelete={removeFilter(ExternalOrdersFieldKeys.STATUS)}
        />
      )}

      {filter?.createdAt && (
        <Chip
          label={`Created At = ${format(new Date(filter.createdAt), 'MM/dd/yyyy')}`}
          variant='contained'
          onDelete={removeFilter(SortKey.CREATED_AT)}
        />
      )}

      {!isEmpty(compact(values(filter))) && <Button onClick={removeAllFilter}>Remove All</Button>}
    </Stack>
  );
};

export default ProcessedExternalOrdersFilterStatusBar;
